// React
import React from "react";
import classNames from "classnames";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./StatsCard.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
const StatsCard = ({ heading, headingSubtext, thickPadding, children }) => {
    let displayText = heading;
    if (headingSubtext) {
        displayText = `${heading} - ${headingSubtext}`;
    }
    return (React.createElement("div", { className: classNames(styles.card, thickPadding && styles.thickPadding) },
        displayText && React.createElement("span", { className: styles.heading }, displayText),
        children));
};
export default StatsCard;
